export default {
  options: {
    none: 'Ingen kampagnekode til start',
  },
  buttons: {
    next: 'Næste',
    back: 'Tilbage',
    skip: 'Spring over',
  },
};
